import {
  GetStaffsQueryParams,
  Staff as StaffType,
  StaffListWithPagination,
  StaffPatch,
  StaffPost,
  StaffResponse,
} from 'types/Staff'

import { apiClient } from './api'
import { apiv2Client } from './apiv2'

export const getStaffs = async (params: any = {}) => {
  const data: any = await apiClient.get<StaffType[]>('/api/v1/staffs/all', {
    params,
  })
  return data
}

export const createStaffV2 = async (data: StaffPost) => {
  const res: StaffResponse = await apiv2Client.post('/admin/staffs/', data)
  return res
}

export const getStaffsV2 = async (
  params: GetStaffsQueryParams,
): Promise<StaffListWithPagination> => {
  const res = await apiv2Client.get<StaffListWithPagination>('/admin/staffs/', {
    params,
  })
  return res as unknown as StaffListWithPagination
}

export const getInfoStaffV2 = async (staffId: string) => {
  const data: StaffType = await apiv2Client.get(`/admin/staffs/${staffId}`, {})
  return data
}

export const deleteStaffV2 = async (staffId: string) => {
  const res: StaffResponse = await apiv2Client.delete(
    `/admin/staffs/${staffId}`,
    {},
  )
  return res
}
export const updateStaffV2 = async (staffId: string, data: StaffPatch) => {
  const res: StaffResponse = await apiv2Client.put(
    `/admin/staffs/${staffId}`,
    data,
  )
  return res
}

export default {
  getStaffs,
  createStaffV2,
  getInfoStaffV2,
  getStaffsV2,
  deleteStaffV2,
  updateStaffV2,
}
